<script>
export default {
  props: {
    options: { type: Object, required: true, default: () => {} } //配置项
  },

  data() {
    return {
      chart: null, //图表实力对象
      aside: null
    }
  },

  watch: {
    //监听配置参数改变事件
    options: {
      handler() {
        if(this.chart) {
          if(JSON.stringify(this.options.xAxis) != '{}' && JSON.stringify(this.options.xAxis) != '[]' && JSON.stringify(this.options.yAxis) != '{}' && JSON.stringify(this.options.yAxis) != '[]') {
            this.chart.setOption(this.options || {}, true)
          } else {
            this.chart.clear()
          }
        }
      },
      deep: true
    }
  },

  mounted() {
    setTimeout(() => {
      this.chart = this.$echarts.init(this.$refs.chart)

      if(JSON.stringify(this.options.xAxis) != '{}' && JSON.stringify(this.options.xAxis) != '[]' && JSON.stringify(this.options.yAxis) != '{}' && JSON.stringify(this.options.yAxis) != '[]') {
        this.chart.setOption(this.options || {})
      } else {
        this.chart.clear()
      }

      window.addEventListener('resize', this.resize)

      this.aside = document.querySelector('.work-aside')
      this.aside && this.aside.addEventListener('transitionend', this.resize)
    }, 20)
  },

  methods: {
    //浏览器尺寸改变事件
    resize() {
      if(this.chart) this.chart.resize()
    },

    //获取Png图片
    getPng() {
      if(!this.chart) return
      return this.chart.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#fff' })
    },

    setOption() {
      this.chart.setOption(this.options || {}, true)
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.resize)
    this.aside && this.aside.removeEventListener('transitionend', this.resize)
  }
}
</script>

<template>
  <div ref="chart" class="chart"></div>
</template>

<style scoped lang="scss">
.chart{
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
